// import React from 'react';
// import '../../styles/activities.css';
// import activitiesData from '../../data/activitiesData';

// function Activities() {
//   return (
//     <>
//       <div className="act-wrap">
//         <div className="act-box">
//           <p>EXPERIENCE VS CLUB</p>
//         </div>
//         <div className="act-slider">
//           <div className="slide-track">
//               {activitiesData.map((items, index) => (
//                 <div className="slide" key={index}>
//                   <img src={items.actImg} alt="Activities" />
//                   <p>{items.actDesc}</p>
//                 </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// export default Activities

import React from 'react';
import '../../styles/activities.css';

function Activities() {
  const promos = [
    { id: 1, img: "/vscimages/ads/sports-run.jpg" },
    { id: 2, img: "/vscimages/ads/buddy.jpg" },
    { id: 3, img: "/vscimages/ads/premier-apr.jpg"},
    // { id: 3, img: "/vscimages/ads/buddy.jpg"},
    // { id: 4, img: "/vscimages/ads/3+1.jpg"},
    // If you add a 5th, it will automatically go to the next row
  ];

  return (
    <section className="promo-section">
      <div className="promo-header">
        <h2>Discover Our Experiences</h2>
        <div className="header-line"></div>
      </div>

      <div className="promo-grid-container">
        {promos.map((promo) => (
          <div className="promo-card" key={promo.id} data-aos="fade-up">
            <div className="promo-img-wrapper">
              <img src={promo.img} alt={promo.title} />
              {/* <div className="promo-overlay">
                <span className="promo-tag">{promo.tag}</span>
                <div className="promo-info">
                  <h3>{promo.title}</h3>
                </div>
              </div> */}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Activities;